// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"139":"app-messages-en_US","881":"product-metadata"}[chunkId] + "." + {"139":"a26c72fa","881":"22aa34b5"}[chunkId] + ".chunk.js";
};